import { render } from "./P_Longsword.vue?vue&type=template&id=73f308fd&scoped=true"
import script from "./P_Longsword.vue?vue&type=script&lang=js"
export * from "./P_Longsword.vue?vue&type=script&lang=js"

import "./P_Longsword.vue?vue&type=style&index=0&id=73f308fd&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f308fd"]])

export default __exports__